<template>
    <div class="footerContainer">
        <a v-if="settings.brandVisible" class="footer-banner" href="https://supsis.com" style="" target="_blank">
            <p class="footer-text">POWERED BY</p>
            <img
                :src="baseUrl().concat('static/img/footer-logo.svg')"
                class="mx-1"
            />
        </a>
        <div v-if="loginFormRequired" class="footerCatalogBtns">
            <md-button :class="activeTab === 0 ? 'md-raised' : 'main-text-color'" class="tabBtn" @click="activeTab = 0">
                Chat
            </md-button>
            <md-button
                :class="activeTab === 1 ? 'md-raised ' : 'main-text-color'"
                class="tabBtn"
                @click="activeTab = 1"
            >
                Help Center
            </md-button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Rate from "./Rate";
import SearchIcon from "./../svg/SearchIcon";
import ChatIcon from "./../svg/ChatIcon";

export default {
    name: "Footer",
    components: { Rate, SearchIcon, ChatIcon },
    data () {
        return {
            activeTab: 0,
        };
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            loginFormRequired: (state) => {
                const loginFormRequired = state.setting.settings.loginFormRequired;
                const customLoginFormEnabled = state.setting.settings.customLoginFormEnabled;
                const customLoginFormIsValid = !!state.customLoginForm.inputs.filter((x) => x.visible).length;
                if (customLoginFormEnabled && !customLoginFormIsValid) {
                    return false;
                } else {
                    return loginFormRequired;
                }
            },
        }),
        ...mapGetters({
            ChatConnected: "chat/isConnected",
        }),
    },
    props: [],
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
        }),
        baseUrl: () => {
            if (document.currentScript) {
                let _documentUrl = document.currentScript.src.split("/");
                return _documentUrl[0] + "//" + _documentUrl[2] + "/";
            } else {
                return "/";
            }
        },
    },
    watch: {
        activeTab (newValue) {
            this.$emit("change-active-tab", newValue);
        },
    },
};
</script>

<style lang="scss" scoped>
.footerContainer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;


    .footerCatalogBtns {
        padding: 0 !important;
        display: flex;
        justify-content: space-between;
        align-content: stretch;

        .tabBtn {
            width: 50%;
            color: var(--color4);
            background-color: var(--color1);
        }

        .tabBtn > * {
            padding: 0;
            margin: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/Footer.vue